module.exports = __webpack_public_path__ + "static/media/badge-cn.6222ee1d.png";